import { selectedCustomerIdStorage } from "features/auth/AuthUtils";
import { useUserCustomerListSuspense } from "gen/endpoints/users/users";
import { AppConfig } from "shared/config/AppConfig";

export const useSelectedCustomerId = () => {
  const [selectedCustomerIdFromStorage] = selectedCustomerIdStorage.use();

  const { data: customers } = useUserCustomerListSuspense();

  const selectedCustomerIdFromUrl = customers.find(
    (c) => c.web_domain === window.location.hostname,
  );

  return AppConfig.subdomains
    ? selectedCustomerIdFromUrl?.id
    : selectedCustomerIdFromStorage;
};
